import { StyledBurger, StyledBurgerLine } from "./elements";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const Hamburger: React.FC<Props> = ({ setOpen, open }) => {
  return (
    <StyledBurger onClick={() => setOpen(!open)}>
      <StyledBurgerLine open={open} />
      <StyledBurgerLine open={open} />
      <StyledBurgerLine open={open} />
    </StyledBurger>
  );
};
